module.exports = __webpack_public_path__ + "static/media/trapmonster.3ee4ce5e.gif";